<template>
  <div>
    <v-select
      v-if="getUserStudents.length > 0"
      :items="getUserStudents"
      label="Switch Student"
      v-model="selectedStudentSid"
      @change="getSelectedStudent()"
    ></v-select>
  </div>
</template>

<script>
import axios from "@/plugins/axios";

export default {
  props: ["userId"],

  computed: {
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getCurrentUser() {
      return this.$store.getters.getCurrentUser;
    },
    getUserStudents() {
      return this.$store.getters.getUserStudents;
    },

    getUserSelectedStudentSid() {
      return this.$$store.getters.getUserSelectedStudentSid;
    },
    itsBitsems() {
      return this.$store.getters.itsBitsems;
    }
  },
  mounted() {
    this.$store.dispatch("setUserStudents", {
      userId: this.userId,
      token: this.getAccessToken
    });
  },
  data: () => ({
    selectedStudentSid: null
  }),
  methods: {
    getSelectedStudent() {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/update-user-sid",
          {
            sid: this.selectedStudentSid,
            userId: this.getCurrentUser.id
          },
          this.getAccessToken
        )
        .then(user => {
          this.$store.commit("setLoader", false);
          this.$store.commit("setCurrentUser", user);
          this.$router.push("/switchboard");
        });
    }
  }
};
</script>

<style>
</style>